import { render, staticRenderFns } from "./PostLocationModal.vue?vue&type=template&id=3fa8f350&"
import script from "./PostLocationModal.vue?vue&type=script&lang=js&"
export * from "./PostLocationModal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports